import { invert } from "lodash"

export const RewardMap = { ...__RECALL_REWARD_MAP }
export const RevertRewardMap = invert(RewardMap)

export enum Reward {
    VR__LMB = "4001",
    VR__EXPC = "2003",
    VR__MTLS = "3303", // 技巧概要
    VR__AMVP = "advanced_material_issue_voucher", // 高级材料
    VR__CP = "voucher_chipPackage", // 自助芯片组印刻仪
    VR__SPM4 = "voucher_skill_specialLevelMax_4", // 专业干员技巧集
    VR__SPM5 = "voucher_skill_specialLevelMax_5", // 资深干员技巧集
    VR__SPM6 = "voucher_skill_specialLevelMax_6", // 高级资深干员技巧集
    VR__VLM4 = "voucher_levelmax_4", // 专业干员特训装置
    VR__VLM5 = "voucher_levelmax_5", // 资深干员特训装置
    VR__VLM6 = "voucher_levelmax_6", // 高级资深干员特训装置
    VR__VE24 = "voucher_elite_II_4", // 专业干员特训邀请函
}

// export const config2Reward = {
//     vr_1: Reward.VR__LMB,
//     vr_2: Reward.VR__EXPC,
//     vr_3: Reward.VR__MTLS,
//     vr_4: Reward.VR__AMVP,
//     vr_5: Reward.VR__CP,
//     vr_6: Reward.VR__VLM4,
//     vr_7: Reward.VR__SPM5,
//     vr_8: Reward.VR__VLM5,
//     vr_9: Reward.VR__SPM6,
//     vr_10: Reward.VR__VLM6,
// }

export const RLSrcs = {
    // TODO  替换为实际的图片
    ["gd-card"]: require("@/assets/imgs/recall/gd_card.png"),
}

export const RLRewardMap: Record<
    string,
    {
        key: string
        name: string
        amount: number
        total?: number | null
        order: number
    }
> = {
    gd_card: {
        key: "gd-card",
        name: "reward.gd_card",
        amount: 1,
        total: 3000,
        order: 0,
    },
}

export const VRRewardMap: Record<
    string,
    {
        key: Reward
        name: string
        amount: number
        total?: number | null
        order: number
        isReveal?: boolean
    }
> = {
    vr_1: {
        key: Reward.VR__LMB,
        name: "reward.lmb",
        amount: 10000,
        total: null,
        order: 7,
    },
    vr_2: {
        key: Reward.VR__AMVP,
        name: "reward.avmp",
        amount: 8,
        total: null,
        order: 6,
    },
    vr_3: {
        key: Reward.VR__CP,
        name: "reward.cp",
        amount: 1,
        total: null,
        order: 5,
    },
    vr_4: {
        key: Reward.VR__SPM5,
        name: "reward.spm5",
        amount: 1,
        total: null,
        order: 4,
    },
    vr_5: {
        key: Reward.VR__VLM5,
        name: "reward.vlm5",
        amount: 1,
        total: null,
        order: 3,
    },
    vr_6: {
        key: Reward.VR__SPM6,
        name: "reward.spm6",
        amount: 1,
        total: null,
        order: 2,
    },
    vr_7: {
        key: Reward.VR__VLM6,
        name: "reward.vlm6",
        amount: 1,
        total: null,
        order: 1,
    },
}
